const validateStomach=(formData)=>
{
    const message0= "NICE recommends:-" 

    const abdoMassMessage = "Consider a suspected cancer pathway referral for people with an upper abdominal mass consistent with stomach cancer."

    const dysphagiaMessage = "Offer urgent, direct access upper gastrointestinal endoscopy (to be done within 2 weeks) to assess for stomach cancer in people with dysphagia"

    const urgentOGD= "Offer urgent, direct access upper gastrointestinal endoscopy (to be done within 2 weeks) to assess for stomach cancer in people aged 55 and over with weight loss and any of the following (upper abdominal pain, reflux, dyspepsia.)"

    const haematemesisMessage = "Consider non-urgent, direct access upper gastrointestinal endoscopy to assess for stomach cancer in people with haematemesis."

    
    const routOGD="Consider non-urgent, direct access upper gastrointestinal endoscopy to assess for stomach cancer in people aged 55 or over with upper abdominal pain with low haemoglobin levels, or raised platelet count with any of the following (nausea, vomiting, weight loss, reflux, dyspepsia,upper abdominal pain) or nausea or vomiting with any of the following (weight loss, reflux, dyspepsia,upper abdominal pain.) "

    const treatmentResistantDysepsia= "Consider non-urgent, direct access upper gastrointestinal endoscopy to assess for oesophageal cancer in people aged 55 or over with treatment‑resistant dyspepsia"
    
    if (formData.upperAbdoMass)
    {
    formData.twrValid.stomach=true
    formData.message.stomach=message0 + abdoMassMessage
    return formData
    } 
    

if (formData.dysphagia)
    {
     formData.message.stomach= message0 +dysphagiaMessage
     formData.investigations.push("Urgent Upper GI Endoscopy")
     return formData   
    }

if (formData.age>=55 && formData.weightLoss && (formData.upperAbdoPain || formData.reflux || formData.dyspepsia))
    {
    formData.message.stomach=message0 + urgentOGD
    formData.investigations.push("Urgent Upper GI Endoscopy")
    return formData    
    }
if (formData.haematemesis)
    {
    formData.message.stomach=message0 + haematemesisMessage
    formData.investigations.push("Routine Upper GI Endoscopy")
    return formData      
    }
     
if (formData.age < 55)
    {
    return formData 
    }
if ((formData.upperAbdoPain && (formData.anaemia || formData.idAnaemia)) || 

(formData.thrombocytosis && (formData.nausea || formData.vomiting || formData.weightLoss || formData.reflux || formData.dyspepsia || formData.upperAbdoPain)) ||

((formData.nausea || formData.vomiting) && (formData.weightLoss || formData.reflux || formData.dyspepsia || formData.upperAbdoPain)))
    {
    formData.message.stomach=message0 + routOGD
    formData.investigations.push("Routine Upper GI Endoscopy")
    return formData
    }
    
if (formData.dyspepsia)
    {
    formData.message.stomach=message0 + treatmentResistantDysepsia
    formData.investigations.push("Routine Upper GI Endoscopy")
    return formData   
    }

return formData
}
    

export default validateStomach